import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderInputs, commonAddressInputs, commonPersonInputs } from "./utils";
import { useSubmit } from "module/common/components/forms";
import { putWorkplace } from "module/main/store/appEndpoints/api";
var Workplace = function (_a) {
    var formSubmitCallBack = _a.formSubmitCallBack, formRef = _a.formRef;
    var handleSubmit = useSubmit(function (request) {
        var street = request.street, city = request.city, state = request.state, zipcode = request.zipcode;
        var hasMailing = [street, city, state, zipcode].some(Boolean);
        var curatedPayload = {
            workplace_lookups: [
                {
                    first_name: request.first_name || null,
                    middle_name: request.middle_name || null,
                    last_name: request.last_name || null,
                    age: request.age || null,
                    email: request.email || null,
                    phone_number: request.phone_number || null,
                    mailing_addresses: hasMailing
                        ? [
                            {
                                street: street || null,
                                city: city || null,
                                state: state || null,
                                zipcode: zipcode || null,
                            },
                        ]
                        : [],
                },
            ],
        };
        formSubmitCallBack(putWorkplace, curatedPayload);
    });
    var restInputs = [
        { id: "age", name: "age", placeholder: "Enter Age", label: "Age", type: "number" },
        { id: "email", name: "email", placeholder: "Enter Email", label: "Email", type: "email" },
        {
            id: "phone_number",
            name: "phone_number",
            placeholder: "Enter Phone Number",
            label: "Phone Number",
            type: "tel",
        },
    ];
    return (_jsxs("form", { onSubmit: handleSubmit, className: "flex flex-col", id: "endpoints-form", ref: formRef, children: [_jsx("h5", { className: "font-bold mb-2", children: "Workplace lookup:" }), _jsx("div", { className: "form-row", children: renderInputs(commonPersonInputs) }), _jsx("div", { className: "form-row", children: renderInputs(restInputs.slice(0, 2), "person") }), _jsx("div", { className: "form-row", children: renderInputs(restInputs.slice(2), "person") }), _jsx("h5", { className: "font-bold mb-2 inline", children: "Mailing address:" }), _jsx("div", { className: "form-row", children: renderInputs(commonAddressInputs.slice(0, 2)) }), _jsx("div", { className: "form-row", children: renderInputs(commonAddressInputs.slice(2)) })] }));
};
export default Workplace;
